module.exports = __webpack_public_path__ + "img/directory--icon.ca0ef439.svg";